export default __webpack_public_path__ + "static/media/3334 knife block A side.53755caf.png";